import React, { useEffect, useState } from "react";
import {
  convertToDate,
  checkInputDecimal,
  CalConvertAmt,
  decimalRemove,
} from "../../utils/inputValueFormat";
import { checkAndAutoCalTax } from "../../utils/taxChecking";
import appConfig from "../../constants/config";
import Autocomplete from "./Autocomplete";
import { format } from "date-fns";
import { AutoComplete } from 'primereact/autocomplete';
import Select from "react-select";
import { subCatInputIdOnInput, subCatInputOnChange } from "../../pages/ClaimItems/services/claimDetailUtils";
import { translate } from "../../utils/translateUtils";
import { getObjectClaimUserInfo, getObjectRequester } from "../../utils/localStorage/localStorage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

interface PerDiemInputsProps {
  idx: number;
  inputValues: { [key: string]: any | undefined };
  inputValuesRef?: any;
  handleInputChange: (id: string, value?: any) => Promise<void>;
  PDEntitlementLocationDDL: any;
  PDEntitlementPercentageDDL: any;
  OutPDEntitlementLocationObjAttr: any;
  OutPDEntitlementPercentageObjAttr: any;
}

const isNullOrEmpty = (value: any): boolean =>
  value == null || value.toString() === "" || value === undefined;

export const PerDiemInputs: React.FC<PerDiemInputsProps> = ({
  idx,
  inputValues,
  handleInputChange,
  PDEntitlementLocationDDL,
  PDEntitlementPercentageDDL,
  OutPDEntitlementLocationObjAttr,
  OutPDEntitlementPercentageObjAttr,
  inputValuesRef = null
}) => {
  // const isNullOrEmpty = (value: any): boolean => value == null || value == '' || value == undefined;
  const objRequestor = getObjectRequester();
  const objClaimUserInfo = getObjectClaimUserInfo();

  const [finalCountryCode, setFinalCountryCode] = useState<string>("");
  const perDiemLocationSprDDL = [{ label: "Apple", value: "1" }];

  const perDiemMealSprDDL = [{ label: "Apple", value: "1" }];

  //Per Diem Control

  //Control Checking for country who can access per diem calculation function
  let temprequestor = objRequestor;

  let final_control_checking_user: any = null;

  if (!isNullOrEmpty(objClaimUserInfo)) {
    final_control_checking_user = objClaimUserInfo;

  } else if (!isNullOrEmpty(temprequestor)) {
    final_control_checking_user = temprequestor;

  }
  else { }

  // Helper to extract the `SPR` keys from inputValues
  const extractNumOfDaysKeys = (obj: { [key: string]: any }) => {
    return Object.keys(obj).filter(key => key.includes("txtPerDiem_NumberofDaysSPR"));
  };

  // Get an array of `SPR` keys
  const SPRKeys = extractNumOfDaysKeys(inputValues);

  // Create a "dependencies" array of SPR key values for useEffect
  const numOfDayValues = SPRKeys.map(key => inputValues[key]);

  const country_per_diem_control = appConfig.PerDiemControlCountry.split(",");
  const perDiemColumn = appConfig.PerDiemColumn;

  useEffect(() => {
    if (!isNullOrEmpty(final_control_checking_user)) {
      if (
        country_per_diem_control.includes(
          final_control_checking_user?.country_code
        )
      ) {
        setFinalCountryCode(final_control_checking_user?.country_code);
      }
    }
  }, [final_control_checking_user]);

  useEffect(() => {
    if (!isNullOrEmpty(inputValues[`perDiemCalTotalAmountCallback`])) {
      perDiemCalTotalAmount(idx, inputValues, handleInputChange, inputValuesRef);
    }
  }, [inputValues[`perDiemCalTotalAmountCallback`]]);

  return !isNullOrEmpty(finalCountryCode) ? (
    <>
      <label id={`lblPerDiemTitle${idx}`} data-tag="Per_diem_calculation_label">
        {inputValues[`ddlCategory${idx}`] == "51"
          ? translate("Daily allowance calculation")
          : translate("Per diem calculation")}
      </label>
      {Array.from({ length: perDiemColumn }, (_, index) => {
        let a = index + 1; // Start 'a' from 1 instead of 0
        return (
          <div
            id={`divPerdiem${a}_${idx}`}
            className={a !== 1 ? "d-none" : ""}
            style={{ paddingBottom: "15px" }}
          >
            <div className="mb-2">
              <div className="input-group">
                <div
                  className={
                    finalCountryCode === "TH" || finalCountryCode === "MM"
                      ? "col-sm-12"
                      : "col-sm-5"
                  }
                  style={{ paddingLeft: "0px" }}
                >
                  <label
                    htmlFor={`txtPerDiemLocationSPR${a}_${idx}`}
                    id={`lblPerDiemLocationSPR${a}_${idx}`}
                    data-tag={
                      finalCountryCode === "TH" || finalCountryCode === "MM"
                        ? "Position"
                        : "Location"
                    }
                  >
                    {finalCountryCode === "TH" || finalCountryCode === "MM"
                      ? "Position"
                      : "Location"}
                  </label>
                  &nbsp;<span className={`txtPerDiemLocationSPR${a}_${idx}_asterisk ${a == 1 ? "" : "d-none"}`} style={{ color: "red" }}>*</span>
                  {/* <Autocomplete
                  dataList={PDEntitlementLocationDDL}
                  id={`txtPerDiemLocationSPR${a}_${idx}`}
                  handleAutoCompleteChange={(e) => {
                    handleInputChange(
                      `txtPerDiemLocationSPR${a}_${idx}`,
                      e.target.value
                    );
                    PerDiemCalculation({
                      idx: idx,
                      id: `txtPerDiemLocationSPR${a}_${idx}`,
                      inputValues,
                      handleInputChange,
                    });
                  }}
                  placeholder=""
                  className="form-control"
                  isRequired={a == 1}
                /> */}
                  {/* Begin, Saber, 20260818, INC-1023323 - Preserve zero-value position entries (e.g. CDT) as valid selections */}
                  <Select
                    isClearable={true}
                    isSearchable={true}
                    value={
                      !isNullOrEmpty(inputValues[`txtPerDiemLocationSPR${a}_${idx}`])
                        ? PDEntitlementLocationDDL?.find(
                          (option: any) =>
                            option.value == inputValues[`txtPerDiemLocationSPR${a}_${idx}`]
                        )
                        : ''
                    }
                    options={PDEntitlementLocationDDL}
                    id={`txtPerDiemLocationSPR${a}_${idx}`}
                    onChange={(e) => {
                      handleInputChange(`txtPerDiemLocationSPR${a}_${idx}`, e?.value);
                      handleInputChange(`txtPerDiemLocationSPR${a}_${idx}_text`, e?.label);
                      handleInputChange(`txtPerDiemLocationSPR${a}_${idx}_currency_code`, e?.currency_code);
                      handleInputChange(`txtPerDiemLocationSPR${a}_${idx}_location_type`, e?.location_type);
                      handleInputChange(`txtPerDiem_NumberofDaysSPR${a}_${idx}`, 0);
                      perDiemCalculation(
                        idx,
                        `txtPerDiemLocationSPR${a}_${idx}`,
                        inputValues,
                        handleInputChange,
                        e?.value,
                        null,
                        0,
                        null,
                        inputValuesRef
                      );
                      subCatInputOnChange(
                        inputValues,
                        idx,
                        "txtPerDiemLocationSPR",
                        handleInputChange,
                        `txtPerDiemLocationSPR${a}_${idx}`
                      );
                    }}
                    onBlur={() => {
                      subCatInputOnChange(
                        inputValues,
                        idx,
                        "txtPerDiemLocationSPR",
                        handleInputChange,
                        `txtPerDiemLocationSPR${a}_${idx}`
                      );
                    }}
                    placeholder={""}
                    className={`${a == 1 ? "select-ddl-required needValue" : ""} react-select-container`}
                    classNamePrefix="react-select"
                  />
                  <div className={`invalid-feedback txtPerDiemLocationSPR${a}_${idx}-invalid-feedback`}>
                    <span className="language">{translate("Required")}</span>
                  </div>
                </div>
                <div
                  id={`divMealEntitlement${a}_${idx}`}
                  className="col-sm-7"
                  style={{ paddingRight: "0px", paddingLeft: "0px" }}
                >
                  <label
                    id="lblMealEntitlement"
                    htmlFor={`txtPerDiemMealSPR${a}_${idx}`}
                    data-tag="Meals_entitlement"
                  >
                    {translate("Meals entitlement")}&nbsp;<span className={`txtPerDiemMealSPR${a}_${idx}_asterisk`} style={{ color: "red" }}>*</span>
                  </label>
                  {/* <select id={`txtPerDiemMealSPR${a}_${idx}`} className="form-control" onChange={() => perdiemcalculation(`txtPerDiemMealSPR${a}_${idx}`)} required={a === 1}>
                          </select> */}
                  {/* <Autocomplete
                  dataList={PDEntitlementPercentageDDL}
                  id={`txtPerDiemMealSPR${a}_${idx}`}
                  handleAutoCompleteChange={(e) => {
                    handleInputChange(
                      `txtPerDiemMealSPR${a}_${idx}`,
                      e.target.value
                    );
                    PerDiemCalculation({
                      idx: idx,
                      id: `txtPerDiemMealSPR${a}_${idx}`,
                      inputValues,
                      handleInputChange,
                      mealVal: e.target.value
                    });
                  }}
                  placeholder=""
                  className="form-control"
                  isRequired={a == 1}
                /> */}
                  <Select
                    isClearable={true}
                    isSearchable={true}
                    value={
                      inputValues[`txtPerDiemMealSPR${a}_${idx}`]
                        ? PDEntitlementPercentageDDL?.find(
                          (option: any) =>
                            option.value == inputValues[`txtPerDiemMealSPR${a}_${idx}`]
                        )
                        : ''
                    }
                    options={PDEntitlementPercentageDDL}
                    id={`txtPerDiemMealSPR${a}_${idx}`}
                    onChange={(e) => {
                      handleInputChange(`txtPerDiemMealSPR${a}_${idx}`, e?.value);
                      handleInputChange(`txtPerDiemMealSPR${a}_${idx}_text`, e?.label);
                      handleInputChange(`txtPerDiemMealSPR${a}_${idx}_percentage_amount`, e?.percentage_amount);
                      handleInputChange(`txtPerDiemMealSPR${a}_${idx}_entitlement_type`, e?.entitlement_type);
                      handleInputChange(`txtPerDiem_NumberofDaysSPR${a}_${idx}`, 0);

                      perDiemCalculation(
                        idx,
                        `txtPerDiemMealSPR${a}_${idx}`,
                        inputValues,
                        handleInputChange,
                        null,
                        e?.value,
                        0,
                        null,
                        inputValuesRef
                      );
                    }}
                    placeholder={""}
                    className={`${a == 1 ? "select-ddl-required needValue" : ""} react-select-container`}
                    classNamePrefix="react-select"
                  />
                  <div className={`invalid-feedback txtPerDiemMealSPR${a}_${idx}-invalid-feedback`}>
                    <span className="language">{translate("Required")}</span>
                  </div>
                </div>
              </div>
            </div>
            <input
              type="text"
              className="form-control language d-none"
              name="textfield"
              value={
                inputValues[`hidtxtTaxable_amt_TH${a}_${idx}`]
                  ? inputValues[`hidtxtTaxable_amt_TH${a}_${idx}`]
                  : ""
              }
              id={`hidtxtTaxable_amt_TH${a}_${idx}`}
            />
            <div className="mb-2" id={`divPerdiemCalculationDetail${a}_${idx}`}>
              <div
                id={`ClientHeadcount${a}_${idx}`}
                className="input-group d-none"
              >
                <label htmlFor="txtPerDiem_AmountOTH" data-tag="Per_Diem_Rate">
                  {translate("Per Diem Rate")}
                </label>
                &nbsp;<span className={`txtPerDiem_AmountOTHSPR${a}_${idx}_asterisk`} style={{ color: "red" }}>*</span>
              </div>
              <div
                id={`ClientHeadcount_txt${a}_${idx}`}
                className="input-group d-none"
              >
                <div className="col-sm-5" style={{ paddingLeft: "0px" }}>
                  <input
                    type="text"
                    className="form-control language"
                    value={
                      inputValues[`txtPerDiem_AmountOTHSPR${a}_${idx}`]
                        ? inputValues[`txtPerDiem_AmountOTHSPR${a}_${idx}`]
                        : ""
                    }
                    onChange={(e) => {
                      perDiemCalculation(
                        idx,
                        `txtPerDiem_AmountOTHSPR${a}_${idx}`,
                        inputValues,
                        handleInputChange,
                        null,
                        null,
                        0,
                        e?.target.value,
                        inputValuesRef
                      );
                    }
                    }
                  />
                </div>
              </div>
              <div className="input-group">
                <div className="col-sm-5" style={{ paddingLeft: "0px" }}>
                  <label id="lblNumberofDaysPerDiem" data-tag="Number_of_days">
                    {translate("Number of Days")}&nbsp;<span className={`txtPerDiem_NumberofDaysSPR${a}_${idx}_asterisk`} style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    id={`txtPerDiem_NumberofDaysSPR${a}_${idx}`}
                    className={`form-control language ${a === 1 ? "needValue" : ""}`}
                    type="number"
                    min="0"
                    value={
                      inputValues[`txtPerDiem_NumberofDaysSPR${a}_${idx}`]
                        ? inputValues[`txtPerDiem_NumberofDaysSPR${a}_${idx}`]
                        : ""
                    }
                    onChange={(e) => {
                      handleInputChange(`txtPerDiem_NumberofDaysSPR${a}_${idx}`, e?.target.value);
                      perDiemCalculation(
                        idx,
                        `txtPerDiem_NumberofDaysSPR${a}_${idx}`,
                        inputValues,
                        handleInputChange,
                        null,
                        null,
                        e?.target.value,
                        null,
                        inputValuesRef
                      );
                    }
                    }
                    onBlur={(e) => {
                      handleInputChange(`txtPerDiem_NumberofDaysSPR${a}_${idx}`, e?.target.value);
                      perDiemCalculation(
                        idx,
                        `txtPerDiem_NumberofDaysSPR${a}_${idx}`,
                        inputValues,
                        handleInputChange,
                        null,
                        null,
                        e?.target.value,
                        null,
                        inputValuesRef
                      );
                    }}
                    required={a === 1}
                    onWheel={(e) => e.currentTarget.blur()} // <-- prevent scroll wheel changes
                  />
                  <div className={`invalid-feedback txtPerDiem_NumberofDaysSPR${a}_${idx}-invalid-feedback`}>
                    <span className="language">{translate("Required")}</span>
                  </div>
                </div>
                <div
                  className="col-sm-5"
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                >
                  <label id="lblTotalAmountPerDiem" data-tag="Total_amount">
                    {translate("Total amount")}&nbsp;<span className={`txtPerDiem_AmountSPR${a}_${idx}_asterisk`} style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    id={`txtPerDiem_AmountSPR${a}_${idx}`}
                    value={
                      inputValues[`txtPerDiem_AmountSPR${a}_${idx}`]
                        ? inputValues[`txtPerDiem_AmountSPR${a}_${idx}`]
                        : ""
                    }
                    className="form-control language"
                    name="price"
                    type="number"
                    disabled
                    // step=".01"
                    style={{ border: "1px solid #ced4da !important" }}
                    onWheel={(e) => e.currentTarget.blur()} // <-- prevent scroll wheel changes
                  />
                  <div className={`invalid-feedback txtPerDiem_AmountSPR${a}_${idx}-invalid-feedback`}>
                    <span className="language">{translate("Required")}</span>
                  </div>
                </div>
                <div
                  className={`col-sm-2 ${finalCountryCode === "MM" ? "d-none" : ""}`}
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "right",
                  }}
                >
                  <button
                    type="button"
                    id={`btnPerDiemAddSPR${a}_${idx}`}
                    style={{ minHeight: "30px",  minWidth: "40px", border: "none" }}
                    onClick={() =>
                      AddPerDiemCal({ id: `btnPerDiemAddSPR${a}_${idx}` })
                    }
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                  &ensp;
                  <button
                    type="button"
                    id={`btnPerDiemDelSPR${a}_${idx}`}
                    style={{ minHeight: "30px", minWidth: "40px", border: "none", float: "right" }}
                    onClick={() =>
                      DeletePerDiemCal({
                        id: `btnPerDiemDelSPR${a}_${idx}`,
                        handleInputChange,
                      })
                    }
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  ) : (
    <></>
  );
};

interface OptionType {
  location_type: string;
  currency_code: string;
  entitlement_amount: number;
  loaction_text: string;
}

interface Props {
  displayData: any[];
  displayEmpty: boolean;
}

export const PDEntitlementLocationAutoComplete: React.FC<Props> = ({ displayData, displayEmpty }) => {
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  useEffect(() => {
    if (displayEmpty) {
      // setFilteredData([{ location_type: '', currency_code: '', entitlement_amount: 0, loaction_text: '' }]);
      setFilteredData(displayData);
    } else {
      setFilteredData(displayData);
    }
  }, [displayData, displayEmpty]);

  const searchLocation = (event: { query: string }) => {
    const query = event.query.toLowerCase();
    const filtered = displayData?.filter((item) =>
      item.label.toLowerCase().startsWith(query)
    );
    setFilteredData(filtered);
  };

  const handleSelect = (e: any) => {
    setSelectedValue(e.value.label);
  };

  return (
    <div>
      <AutoComplete
        value={selectedValue}
        suggestions={filteredData}
        completeMethod={searchLocation}
        field="loaction_text"
        onChange={handleSelect}
        dropdown
        placeholder="Select Location"
      />
    </div>
  );
};


interface AddPerDiemCalProps {
  id: string;
}

export const AddPerDiemCal: React.FC<AddPerDiemCalProps> = ({ id }): any => {
  const idnum = id.split("SPR");
  const temp = idnum[1].split("_");
  const numOfPerDiem = temp[0];
  const numOfPage = temp[1];
  const perDiemColumn = appConfig.PerDiemColumn; //Configuration for number of per diem calculation

  for (let a = 1; a <= perDiemColumn; a++) {
    let divPerdiem = document.querySelector<HTMLElement>(
      `#divPerdiem${a}_${numOfPage}`
    );
    let txtPerDiemLocationSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiemLocationSPR${a}_${numOfPage}`
    );
    let txtPerDiemMealSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiemMealSPR${a}_${numOfPage}`
    );
    let txtPerDiem_NumberofDaysSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiem_NumberofDaysSPR${a}_${numOfPage}`
    );
    let txtPerDiem_AmountSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiem_AmountSPR${a}_${numOfPage}`
    );
    let txtPerDiem_AmountOTHSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiem_AmountOTHSPR${a}_${numOfPage}`
    );

    if (divPerdiem?.classList.contains(`d-none`)) {
      divPerdiem?.classList.remove(`d-none`);
      txtPerDiemLocationSPR!.required = true;
      txtPerDiemMealSPR!.required = true;
      txtPerDiem_NumberofDaysSPR!.required = true;
      txtPerDiem_AmountSPR!.required = true;
      txtPerDiem_AmountOTHSPR!.required = true;
    }
  }
};

interface DeletePerDiemCalProps {
  id: any;
  handleInputChange: (id: string, value?: any) => Promise<void>;
}

export const DeletePerDiemCal: React.FC<DeletePerDiemCalProps> = ({
  id,
  handleInputChange,
}): any => {
  const idnum = id.split("SPR");
  const temp = idnum[1].split("_");
  const numOfPerDiem = temp[0];
  const numOfPage = temp[1];
  const perDiemColumn = appConfig.PerDiemColumn; //Configuration for number of per diem calculation

  for (let a = perDiemColumn; a >= numOfPerDiem; a--) {
    if (a == 1) {
      break;
    }

    let divPerdiem = document.querySelector<HTMLElement>(
      `#divPerdiem${a}_${numOfPage}`
    );
    let ClientHeadcount = document.querySelector<HTMLElement>(
      `#ClientHeadcount${a}_${numOfPage}`
    );
    let ClientHeadcount_txt = document.querySelector<HTMLElement>(
      `#ClientHeadcount_txt${a}_${numOfPage}`
    );

    let txtPerDiemLocationSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiemLocationSPR${a}_${numOfPage}`
    );
    let txtPerDiemMealSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiemMealSPR${a}_${numOfPage}`
    );
    let txtPerDiem_NumberofDaysSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiem_NumberofDaysSPR${a}_${numOfPage}`
    );
    let txtPerDiem_AmountSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiem_AmountSPR${a}_${numOfPage}`
    );
    let txtPerDiem_AmountOTHSPR = document.querySelector<HTMLInputElement>(
      `#txtPerDiem_AmountOTHSPR${a}_${numOfPage}`
    );

    //Once found a division is hidden, it will show and break the loop to end the function
    if (divPerdiem?.classList.contains(`d-none`)) {
      handleInputChange(`txtPerDiemLocationSPR${a}_${numOfPage}`, "");
      txtPerDiemLocationSPR!.required = false;

      handleInputChange(`txtPerDiemMealSPR${a}_${numOfPage}`, "");
      txtPerDiemMealSPR!.required = false;

      handleInputChange(`txtPerDiem_NumberofDaysSPR${a}_${numOfPage}`, "");
      txtPerDiem_NumberofDaysSPR!.required = false;

      handleInputChange(`txtPerDiem_AmountSPR${a}_${numOfPage}`, "");
      txtPerDiem_AmountSPR!.required = false;

      handleInputChange(`txtPerDiem_AmountOTHSPR${a}_${numOfPage}`, "");
      txtPerDiem_AmountOTHSPR!.required = false;

      divPerdiem?.classList.add(`d-none`);
      ClientHeadcount?.classList.remove(`d-none`);
      ClientHeadcount_txt?.classList.remove(`d-none`);

      // perDiemCalTotalAmount(idx, {}, handleInputChange, null);
      break;
    }
  }
};

// Define the type for the items within dataList
interface DataItemPDLocation {
  currency_code: string;
  location_type: string;
  value: string;
  label: string;
}

// Define the props for the component
interface BindDDLsPDEntitlementLocationProps {
  dataList: DataItemPDLocation[];
  objAttr: any;
}

export const BindDDLsPDEntitlementLocation: React.FC<
  BindDDLsPDEntitlementLocationProps
> = ({ dataList, objAttr }): any => {

  // Begin, Saber, 20260818, INC-1023323 - Normalize entitlement amount into numeric text for stable downstream calculations
  const toNumericString = (value: any): string => {
    const raw = (value ?? "").toString().trim();
    if (raw === "") return "";
    const cleaned = raw.replace(/,/g, "").match(/-?\d+(?:\.\d+)?/);
    return cleaned ? cleaned[0] : "";
  };

  const dataItem: DataItemPDLocation[] = dataList.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
    return {
      currency_code: item.currency_code,
      location_type: item.location_type,
      value: toNumericString(item.entitlement_amount),
      label: item.loaction_text,
    };
  });
  const arrItem = Array.from(new Set(dataItem.map(item => JSON.stringify(item))))
    .map(str => JSON.parse(str) as DataItemPDLocation);

  arrItem.unshift({
    currency_code: "",
    location_type: "",
    value: "",
    label: "",
  });

  return arrItem;
};

// Define the type for the items within dataList
interface DataItemPDPercentage {
  percentage_amount: string;
  entitlement_type: string;
  value: string;
  label: string;
}

// Define the props for the component
interface BindDDLsPDEntitlementPercentageProps {
  dataList: DataItemPDPercentage[];
  objAttr: any;
}

export const BindDDLsPDEntitlementPercentage: React.FC<
  BindDDLsPDEntitlementPercentageProps
> = ({ dataList, objAttr }): any => {
  const dataItem: DataItemPDPercentage[] = dataList.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
    return {
      percentage_amount: item.percentage_amount,
      entitlement_type: item.entitlement_type,
      value: item.percentage_amount,
      label: item.entitlement_type,
    };
  });
  return Array.from(new Set(dataItem.map(item => JSON.stringify(item))))
    .map(str => JSON.parse(str) as DataItemPDPercentage);
};

interface PerDiemCalculationProps {
  idx: number | undefined;
  id: any;
  inputValues: { [key: string]: any | undefined };
  handleInputChange: (id: string, value?: any) => Promise<void>;
  locationVal?: any;
  mealVal?: any;
  numDaysVal?: any;
  locationTextVal?: any;
  inputValuesRef?: any;
}

export function perDiemCalculation(
  idx: number | undefined,
  id: any,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  locationVal?: any,
  mealVal?: any,
  numDaysVal?: any,
  locationTextVal?: any,
  inputValuesRef?: any,
) {
  // Begin, Saber, 20260818, INC-1023323 - Parse formatted numeric values safely to prevent NaN in Per diem totals
  const toNumber = (value: any): number => {
    const raw = (value ?? "").toString().trim();
    if (raw === "") return NaN;
    const cleaned = raw.replace(/,/g, "").match(/-?\d+(?:\.\d+)?/);
    if (!cleaned) return NaN;
    const n = Number(cleaned[0]);
    return Number.isFinite(n) ? n : NaN;
  };

  const idnum = id.split("SPR");
  const temp = idnum[1].split("_");
  const numOfPerDiem = temp[0];
  const numOfPage = temp[1];

  //check variable value
  let location_val = !isNullOrEmpty(locationVal) ? locationVal :
    inputValues[`txtPerDiemLocationSPR${numOfPerDiem}_${numOfPage}`];
  let meal_val = !isNullOrEmpty(mealVal) ? mealVal : inputValues[`txtPerDiemMealSPR${numOfPerDiem}_${numOfPage}`];
  let number_of_days = !isNullOrEmpty(numDaysVal) ? numDaysVal :
    inputValues[`txtPerDiem_NumberofDaysSPR${numOfPerDiem}_${numOfPage}`];
  let is_valid = 1;
  let location_text = !isNullOrEmpty(locationTextVal) ? locationTextVal :
    inputValues[`txtPerDiemLocationSPR${numOfPerDiem}_${numOfPage}_text`];
  let number_of_decimal = decimalRemove();

  const ClientHeadcount = document.querySelector<HTMLInputElement>(
    `#ClientHeadcount${numOfPerDiem}_${numOfPage}`
  );
  const ClientHeadcount_txt = document.querySelector<HTMLInputElement>(
    `#ClientHeadcount_txt${numOfPerDiem}_${numOfPage}`
  );

  if (location_text == "Client Headcount") {
    ClientHeadcount?.classList.remove(`d-none`);
    ClientHeadcount_txt?.classList.remove(`d-none`);
    location_val =
      inputValues[`txtPerDiem_AmountOTHSPR${numOfPerDiem}_${numOfPage}`];
  } else {
    ClientHeadcount?.classList.add(`d-none`);
    ClientHeadcount_txt?.classList.add(`d-none`);
  }

  if (
    number_of_days == null ||
    number_of_days == undefined ||
    number_of_days == "" ||
    isNaN(number_of_days)
  ) {
    is_valid = 0;
    handleInputChange(`txtPerDiem_AmountSPR${numOfPerDiem}_${numOfPage}`, "");
  } else if (
    (meal_val == null || meal_val == undefined || meal_val == "") &&
    inputValues[`hidCountryCode`] != "TH"
  ) {
    is_valid = 0;
    handleInputChange(`txtPerDiem_AmountSPR${numOfPerDiem}_${numOfPage}`, "");
  } else if (
    location_val == null ||
    location_val == undefined ||
    location_val == ""
  ) {
    is_valid = 0;
    handleInputChange(`txtPerDiem_AmountSPR${numOfPerDiem}_${numOfPage}`, "");
  }

  if (is_valid == 1) {
    const locationNumber = toNumber(location_val);
    const mealNumber = toNumber(meal_val);
    const daysNumber = toNumber(number_of_days);

    if (
      !Number.isFinite(locationNumber) ||
      !Number.isFinite(daysNumber) ||
      (inputValues[`hidCountryCode`] != "TH" && !Number.isFinite(mealNumber))
    ) {
      handleInputChange(`txtPerDiem_AmountSPR${numOfPerDiem}_${numOfPage}`, "");
      return;
    }

    let final_value = locationNumber * (mealNumber / 100) * daysNumber;

    if (inputValues[`hidCountryCode`] == "TH") {
      final_value = locationNumber * daysNumber;
      if (locationNumber > 270) {
        let taxable_amt = (locationNumber - 270) * daysNumber;
        handleInputChange(
          `hidtxtTaxable_amt_TH${numOfPerDiem}_${numOfPage}`,
          taxable_amt.toString()
        );
      } else {
        handleInputChange(
          `hidtxtTaxable_amt_TH${numOfPerDiem}_${numOfPage}`,
          final_value.toString()
        );
      }
    }

    handleInputChange(`txtPerDiem_AmountSPR${numOfPerDiem}_${numOfPage}`, final_value.toFixed(number_of_decimal).toString());

    perDiemCalTotalAmount(idx, inputValues, handleInputChange, inputValuesRef); // Calculate total amount

    handleInputChange(`perDiemCalTotalAmountCallback`, final_value.toFixed(number_of_decimal).toString());

  }
};

interface PerDiemCalTotalAmountProps {
  idx: number | undefined;
  inputValues: { [key: string]: any | undefined };
  handleInputChange: (id: string, value?: any) => Promise<void>;
  inputValuesRef?: any
}

export function perDiemCalTotalAmount(
  idx: number | undefined,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  inputValuesRef?: any
) {
  const perDiemColumn = appConfig.PerDiemColumn; //Configuration for number of per diem calculation
  const input_decimal = checkInputDecimal(parseInt(idx!.toString()), inputValues);

  let final_claim_amount = 0;

  console.log("inputValues : =================================");
  console.log(inputValues);
  // console.log(inputValues);
  for (let a = 1; a <= perDiemColumn; a++) {
    let txtPerDiem_NumberofDaysSPR = document.querySelector<HTMLSelectElement>(
      `#txtPerDiem_NumberofDaysSPR${a}_${idx}`
    );
    if (txtPerDiem_NumberofDaysSPR?.classList.contains("needValue")) {
      final_claim_amount =
        final_claim_amount +
        parseFloat(!isNullOrEmpty(inputValues[`txtPerDiem_AmountSPR${a}_${idx}`]) ? inputValues[`txtPerDiem_AmountSPR${a}_${idx}`].toString() : "0");

    } else {
      break; //Break when there is no value is found
    }
  }

  if (input_decimal == 0) {
    final_claim_amount = Math.floor(final_claim_amount);
  }

  //Specific control for per diem auto calculate
  //If user are found from china, auto calculate for total amount is prohibited on this level
  //Other country will remain normal as usual where total amount will be automatically calculated
  //Control Checking for country who can access per diem calculation function
  const temprequestor = getObjectRequester();
  const objClaimUserInfo = getObjectClaimUserInfo();
  const objAttachment = localStorage.getItem("objAttachment") ? JSON.parse(localStorage.getItem("objAttachment")!) : null;


  let final_control_checking_user;

  if (!isNullOrEmpty(objClaimUserInfo)) {
    final_control_checking_user = objClaimUserInfo;
  } else if (!isNullOrEmpty(temprequestor)) {
    final_control_checking_user = temprequestor;
  }

  // console.log("final_claim_amount : " + final_claim_amount);
  if (final_control_checking_user?.country_code != "CN") {
    handleInputChange(
      `txtClaimAmount${idx}`,
      parseFloat(final_claim_amount.toString()).toFixed(input_decimal)
    );
    subCatInputOnChange(inputValues, idx, "txtClaimAmount", handleInputChange, parseFloat(final_claim_amount.toString()).toFixed(input_decimal));
  }

  CalConvertAmt(idx!.toString(), inputValues, input_decimal, handleInputChange);
  checkAndAutoCalTax(
    idx!,
    inputValues,
    handleInputChange,
    temprequestor,
    objAttachment
  );
};

export function calPerDiemDate(
  idx: number | undefined,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  startDateTime: any,
  endDateTime: any
) {
  const is_valid = 1;
  let num_of_days = 0;
  const perDiemColumn = appConfig.PerDiemColumn;

  let start_date = new Date();
  let end_date = new Date();

  if (ValidateDOB({ dob: format(startDateTime, "MM/dd/yyyy") })) {
    start_date = startDateTime;
  }
  if (ValidateDOB({ dob: format(endDateTime, "MM/dd/yyyy") })) {
    end_date = endDateTime;
  }

  if (
    start_date != undefined &&
    start_date != null &&
    start_date.toString() != "" &&
    end_date != undefined &&
    end_date != null &&
    end_date.toString() != ""
  ) {
    // To calculate the time difference of two dates
    let Difference_In_Time = end_date.getTime() - start_date.getTime();

    // To calculate the no. of days between two dates
    num_of_days = Difference_In_Time / (1000 * 3600 * 24) + 1;

    //Prevent negative days
    if (num_of_days < 0) {
      num_of_days = 0;
    }

    //Autopopulate function for invoice/receipt date for global
    if (num_of_days > 0) {
      handleInputChange(`txtStartDate${idx}`, start_date);
      handleInputChange(`txtEndDate${idx}`, end_date);
    }
  } else {
    for (let a = 1; a <= perDiemColumn; a++) {
      let txtPerDiem_NumberofDaysSPR = document.querySelector<HTMLInputElement>(
        `#txtPerDiem_NumberofDaysSPR${a}_${idx}`
      );
      txtPerDiem_NumberofDaysSPR!.max = num_of_days.toString();
    }
  }
};

//Function public validate date function
interface ValidateDOBProps {
  dob: string;
}

export const ValidateDOB: React.FC<ValidateDOBProps> = ({ dob }): any => {
  const pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
  if (!dob || !pattern.test(dob)) {
    return false;
  } else {
    return true;
  }
};

